import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=fbc05248&scoped=true&"
import script from "./Promotions.vue?vue&type=script&lang=js&"
export * from "./Promotions.vue?vue&type=script&lang=js&"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=fbc05248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc05248",
  null
  
)

export default component.exports